import { render, staticRenderFns } from "./DishCard.vue?vue&type=template&id=102ea7c4&scoped=true"
import script from "./DishCard.vue?vue&type=script&lang=js"
export * from "./DishCard.vue?vue&type=script&lang=js"
import style0 from "./DishCard.vue?vue&type=style&index=0&id=102ea7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102ea7c4",
  null
  
)

export default component.exports